import axios from 'axios';
import { baseUrl } from './base';

export async function acceptInvite(token: string) {
  const res = await axios.post(`${baseUrl.TERMINAL}/user-management/users/invite/member/confirm`, {
    token,
  });
  return res.data;
}
